import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ lenis }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    if (lenis) {
      // Use Lenis smooth scroll to top
      lenis.scrollTo(0, { immediate: true });
    } else {
      // Fallback to native scroll
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);

  return null;
};

export default ScrollToTop;
